<template>
  <div
    class="main-layout__item main-layout__item_hover"
    :class="{
      delete: item.delete,
    }"
  >
    <div class="w-3 t-c">
      <p>{{ index }}</p>
    </div>
    <div class="w-5 main-layout__item-image">
      <img :src="item.small_image || defaultImage" alt />
    </div>
    <div class="w-14">
      <p>{{ item.email }}</p>
    </div>
    <div class="w-14">
      <p>{{ fullname }}</p>
    </div>
    <div class="w-14">
      <p>{{ item.phone }}</p>
    </div>
    <div class="w-14">
      <p v-show="item.role.slug">{{ getRoles(item.role.slug) }}</p>
    </div>
    <div class="main-layout__item-actions">
      <div>
        <svg
          @click="openAdminModal(item.id)"
          width="24px"
          height="24px"
          class="main-layout__item-icon"
        >
          <use xlink:href="/images/svg/symbols.svg#svg-user-message" />
        </svg>
      </div>
      <div>
        <svg
          @click="openDeleteModal(item.id)"
          width="24px"
          height="24px"
          class="main-layout__item-icon"
        >
          <use xlink:href="/images/svg/symbols.svg#svg-user-del" />
        </svg>
      </div>

      <div
        class="administrators-item__delete"
        v-if="$guard('delete', 'Administrators') && item.delete"
      >
        <svg
          @click="confirm(item.id)"
          width="30px"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 492 492"
          xml:space="preserve"
          class="main-layout__item-icon"
        >
          <g>
            <g>
              <path
                d="M484.128,104.478l-16.116-16.116c-5.064-5.068-11.816-7.856-19.024-7.856c-7.208,
                                    0-13.964,2.788-19.028,7.856
                                    L203.508,314.81L62.024,173.322c-5.064-5.06-11.82-7.852-19.028-7.852c-7.204,
                                    0-13.956,2.792-19.024,7.852l-16.12,16.112
                                    C2.784,194.51,0,201.27,0,208.47c0,7.204,2.784,
                                    13.96,7.852,19.028l159.744,159.736c0.212,
                                    0.3,0.436,0.58,0.696,0.836
                                    l16.12,15.852c5.064,5.048,11.82,7.572,19.084,
                                    7.572h0.084c7.212,0,13.968-2.524,19.024-7.572l16.124-15.992
                                    c0.26-0.256,0.48-0.468,0.612-0.684l244.784-244.76C494.624,
                                    132.01,494.624,114.966,484.128,104.478z"
              />
            </g>
          </g>
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
        </svg>
        <svg
          @click="decline(item.id)"
          width="25px"
          class="dismiss"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 512.001 512.001"
          xml:space="preserve"
        >
          <g>
            <g>
              <path
                d="M294.111,256.001L504.109,46.003c10.523-10.524,10.523-27.586,
                                0-38.109c-10.524-10.524-27.587-10.524-38.11,0L256,217.892
                                L46.002,7.894c-10.524-10.524-27.586-10.524-38.109,0s-10.524,
                                27.586,0,38.109l209.998,209.998L7.893,465.999
                                c-10.524,10.524-10.524,27.586,0,38.109c10.524,
                                10.524,27.586,10.523,38.109,0L256,294.11l209.997,209.998
                                c10.524,10.524,27.587,10.523,38.11,0c10.523-10.524,
                                10.523-27.586,0-38.109L294.111,256.001z"
              />
            </g>
          </g>
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import debounce from '@/utils/debounce'

export default {
    props: ['item', 'index'],
    name: 'administrators-item-item',
    computed: {
        fullname() {
            return `${this.item.first_name} ${this.item.last_name}`
        },
    },
    data() {
        return {
            defaultImage: '/images/default-user.svg',
        }
    },
    methods: {
        ...mapMutations({
            openDeleteModal: 'administrators/openDeleteModal',
        }),
        ...mapActions({
            fetchById: 'administrators/fetchById',
        }),
        openAdminModal: debounce(async function fn(id) {
            await this.fetchById(id)
        }, 2000),
        // eslint-disable-next-line no-unused-vars
        confirm(id) {
            // console.log(id);
        },
        // eslint-disable-next-line no-unused-vars
        decline(id) {
            // console.log(id);
        },
        getRoles(slug) {
            return this.$t(`roles.${slug.replace('-', '')}`)
        },
    },
}
</script>
